import InfoBar from '~/components/InfoBar';

const mixin = (amount = 1) => {
  return {
    components: {
      InfoBar,
    },
    data() {
      return {
        infoBarArray: [],
        successConfig: { icon: 'check-border', color: '#ff6e00' },
        errorConfig: { icon: 'wrong', color: '#fc223e' },
      };
    },
    created() {
      for (let i = 0; i < amount; i++) {
        this.infoBarArray.push({
          isActive: false,
          message: '',
          config: {
            icon: '',
            color: '',
          },
        });
      }
    },
    methods: {
      showInfoBar(index) {
        this.infoBarArray[index].isActive = true;
      },
      hideInfoBar(index) {
        this.infoBarArray[index].isActive = false;
      },
      setInfoBarMessage(index, message) {
        this.infoBarArray[index].message = message;
      },
      setInfoBarConfig(index, { icon, color }) {
        this.infoBarArray[index].config.icon = icon;
        this.infoBarArray[index].config.color = color;
      },
    },
  };
};

export default mixin;
